import axios, { AxiosResponse } from "axios";
import { HealthModule } from "@/store/health.module";
import { LocaleService } from "./locale.service";
import { AuthService } from "./auth.service";
import { ApiErrorMessages } from "@/config/consts";

import { DialogsModule } from "@/store/dialogs.module";
import i18n from "@/plugins/i18n";

const api = axios.create({
  baseURL: "/api/public",
});

const tokenApi = axios.create({
  baseURL: "/api/public",
});

export const setApiServiceLocale = () => {
  api.defaults.headers.common["Accept-Language"] = LocaleService.getLocale();
};

setApiServiceLocale();

api.interceptors.request.use(req => {
  const token = AuthService.getToken();
  if (token) {
    req.headers["Authorization"] = `Bearer ${token}`;
  }
  return req;
});

api.interceptors.response.use(
  response => {
    if (HealthModule.isSystemInMaintenance)
      HealthModule.setSystemInMaintenance(false);
    return response;
  },
  async error => {
    const res = error.response as AxiosResponse<any>;
    if (res) {
      const message = res.data.message?.message || res.data.message;
      if (message == ApiErrorMessages.NO_SESSION) {
        AuthService.logout();
      } else if (message) {
        switch (res.status) {
          case 400:
            break;
          case 401:
            // if unauthorized
            if (res.data?.message?.message == ApiErrorMessages.UNAUTHORIZED) {
              // try to refresh the token
              const { status } = await AuthService.refreshToken();
              if (status == 201) {
                // if okay, try the original request again
                return api.request(res.config);
              }
            }
            await AuthService.logout();
            break;
          case 500:
          case 502:
          case 503:
            HealthModule.changeSystemStatus();
            break;
          case 504: // Request Timeout
            const dialog = {
              show: true,
              text: i18n.t("ui.errors.timeout"),
            };
            DialogsModule.setCustomDialog(dialog);
            break;
        }
      }
    }

    return Promise.reject(error);
  },
);

export { api as Api, tokenApi as TokenApi };
